import type { RequestParameters, StyleSpecification } from "@iventis/mapbox-gl";

export function mapRequestInterceptor(url: string): RequestParameters {
    let urlObject: URL;
    // If the request is for a api.os.uk map tile, add the required srs parameter
    if (!url.startsWith("/")) {
        urlObject = new URL(url);
        if (urlObject.hostname === "api.os.uk") urlObject.searchParams.append("srs", "3857");
    }
    if (urlObject) {
        return { url: urlObject.toString() };
    }
    return { url };
}

/**
 * Gets a mapbox style that can be passed into the mapbox setStyle method
 * If the styleRef is a url string, it fetches the style from the url
 * If the styleRef is a style object, it returns the object directly
 * If the styleRef is a mapbox style url (mapbox://styles/...), it returns the url string directly
 * @param styleRef The style reference, either a url string or a style object
 * @returns Either the style url string or a style object
 */
export async function getBackgroundStyle(styleRef: string | unknown): Promise<string | StyleSpecification> {
    if (typeof styleRef !== "string") return styleRef as StyleSpecification;

    if (styleRef.startsWith("mapbox://")) return styleRef;

    const asset = await fetch(styleRef);
    if (!asset.ok) throw new Error(`Failed to fetch style: ${asset.status} ${asset.statusText}`);
    return asset.json() as Promise<StyleSpecification>;
}
